let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6OITr")).then(() => parcelRequire('1GkD1'));